import { useStorage } from '@vueuse/core'

export type Locale = 'ru' | 'en'

// Дефолт всегда русский — НЕ автоопределяем по navigator.language: язык продукта
// русский, английский браузер не повод показывать en. Сменить — переключатель в
// профиле (AccountPage → setLocale), выбор персистится в localStorage.
//
// Реактивный синглтон: vue-i18n.locale читает initial из этого же ключа, useStorage
// синкает между табами и переживает обновление. Без ручных try/catch вокруг
// localStorage — useStorage сам глотает ошибки в private mode.
export const storedLocale = useStorage<Locale>('locale', 'ru')
